import makeStyles from '@mui/styles/makeStyles';

export default makeStyles((theme) => ({
    legend: {
        fontSize: '13px',

        color: theme.v2 ? theme.colors.carbon : theme.colors.darkGrey80,
    },
}));
